import { forwardRef } from 'react';

export default forwardRef<SVGSVGElement>((props, ref) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="55"
      height="55"
      viewBox="0 0 55 55"
      fill="none"
      ref={ref}
      {...props}
    >
      <path
        d="M50.7303 18.4123C50.7303 27.4273 50.7303 41.7153 50.7303 50.7303M50.7303 50.7303H18.4123M50.7303 50.7303L4.56177 4.56177"
        stroke="white"
        strokeWidth="8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
});
